export default __webpack_public_path__ + "static/media/collection-img-sample1.86777329.png";